/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
/* Services */


const AboutDeviSlide13 = ({ section }) => {
  return (
    <Box bgColor="#000" className={styles.section13Bg}>
      <Box
        maxW="1200px"
        mx="auto"
        height="100%"
        display="flex"
        position="relative"
        alignItems="center"
        flexDir={{ base: 'column', lg: 'row' }}
        minH="100vh"
      >
        <Box
          maxW="366px"
          w={{ base: '90%', md: '100%' }}
          textAlign="center"
          mr={{ base: '0px', md: '34px' }}
          p="2rem"
        >
          <Text color="#D09700" fontSize={{ base: '18px', lg: '24px' }}>
            When Devi, or Shakti, the embodiment of energy, came in contact with
            Shiva, he came awake and took the form of Rudra - the one who
            roared.
          </Text>
        </Box>
        <Box
          maxW="800px"
          w="100%"
          textAlign="center"
          background={`#000 url('${config.imgPath}/d/46272/1684474070-the_source_of_creation_slide.jpg') no-repeat center center`}
          backgroundSize="contain !important"
          display="block"
          minH={{ base: '60vh', lg: '100vh' }}
        ></Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide13;
